module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Ha-Ic.1761e297.png";